export const CONTACTS = [ 
    {KEY: "CONTACT_LIST.ALARMCENTER" },
    {KEY: "CONTACT_LIST.EMBASSY" },
    {KEY: "CONTACT_LIST.BCD_INHOUSE_TRAVELAGENCY" },
    {KEY: "CONTACT_LIST.CORONER" },
    {KEY: "CONTACT_LIST.treating_doctor" },
    {KEY: "CONTACT_LIST.FOREIGN_AFFAIRS" },
    {KEY: "CONTACT_LIST.CLIENT" },
    {KEY: "CONTACT_LIST.CONTACT_PERSON" },
    {KEY: "CONTACT_LIST.ESCORT" },
    {KEY: "CONTACT_LIST.FAMILY" },
    {KEY: "CONTACT_LIST.FINANCE_CLAIMS" },
    {KEY: "CONTACT_LIST.HOTEL" },
    {KEY: "CONTACT_LIST.GENERAL_PRACTITIONER"},
    {KEY: "CONTACT_LIST.AIR_LINE" },
    {KEY: "CONTACT_LIST.MEDICAL_CONTACT_PERSON" },
    {KEY: "CONTACT_LIST.FELLOW_TRAVELER" },
    {KEY: "CONTACT_LIST.NETWORK_AND_PURCHASING" },
    {KEY: "CONTACT_LIST.INSURER" },
    {KEY: "CONTACT_LIST.OTHER" },
    {KEY: "CONTACT_LIST.PATIENT" },
    {KEY: "CONTACT_LIST.SERVICE_DE_PISTE" },
    {KEY: "CONTACT_LIST.TRAVEL_AGENCY" },
    {KEY: "CONTACT_LIST.TOUGUIDE" },
    {KEY: "CONTACT_LIST.SENIOR" },
    {KEY: "CONTACT_LIST.SOS_DOCTOR" },
    {KEY: "CONTACT_LIST.SOS_MOBILITY_HV" },
    {KEY: "CONTACT_LIST.SOS_MEDICAL_LEADER" },
    {KEY: "CONTACT_LIST.SPECIALIST" },
    {KEY: "CONTACT_LIST.TOUROPERATOR" },
    {KEY: "CONTACT_LIST.INTERMEDIARY" },
    {KEY: "CONTACT_LIST.SUPPLIER" },
    {KEY: "CONTACT_LIST.INURANCE_COMPANY" },
    {KEY: "CONTACT_LIST.MANDATE" },
    {KEY: "CONTACT_LIST.HOSPITAL" }
]

